<template>
  <div class="cooperationPage" :class="[_isMobile() ? 'mobilePage' : '']">
    <p class="cooperationTitle">合作单位</p>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">学术指导单位</p>
        <div class="cooperationListBox">
            <div class="cooperationList" v-for="item,index in comLogo.com1" :key="index">{{ item }}</div>
        </div>
    </div>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">学校、科普单位</p>
        <div class="cooperationListBox">
            <div class="cooperationList" v-for="item,index in comLogo.com2" :key="index">{{ item }}</div>
        </div>
    </div>
    <div class="cooperationBox">
        <p class="cooperationBoxTitle">企业</p>
        <div class="cooperationListBox">
            <div class="cooperationList" v-for="item,index in comLogo.com3" :key="index">{{ item }}</div>
        </div>
    </div>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
export default {
  name: '',
  mixins:[mixinDevice],
  components: {},
  data() {
    return {
        comLogo:{}
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.comName1) {
      this.comLogo.com1 = this.tenantConfig.comName1.split("\n");
    }
    if (this.tenantConfig.comName2) {
      this.comLogo.com2 = this.tenantConfig.comName2.split("\n");
    }
    if (this.tenantConfig.comName3) {
      this.comLogo.com3 = this.tenantConfig.comName3.split("\n");
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.cooperationPage{
    padding: 40px;
    background-image: url('../assets/aice2/HZQY_BACKGROUND.png');
    background: 100% auto;
    .cooperationTitle{
        font-weight: 600;
        font-size: 32px;
        color: #fff;  
        line-height: 46px;
        text-align: center;
    }
    .cooperationBox{
        margin-bottom: 40px;
        .cooperationBoxTitle{
            font-weight: 600;
            font-size: 20px;
            color: #fff;
            line-height: 23px;
            text-align: center;
        }
        .cooperationListBox{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
        }
        .cooperationList{
            width: auto;
            margin:7px 15px;
            color: #fff;
            font-size: 14px;
            line-height: 23px;
        }
    }
}
.mobilePage{
    padding: 12px !important;
    .cooperationBox{
        margin-bottom: 16px !important;
    }
    .cooperationBoxTitle{
        font-size: 14px !important;
        color: #323335 !important;
    }
    .cooperationList{
        margin:5px;
    }
}
</style>
